(function () {
  var NAV_OFFSET_FALLBACK = 72;

  function getNavOffset() {
    var root = document.documentElement;
    if (root.classList.contains('lp-pdp-subnav-pinned')) {
      var subnav = parseInt(getComputedStyle(root).getPropertyValue('--lp-pdp-subnav-height'), 10);
      if (Number.isFinite(subnav) && subnav > 0) return subnav;
    }
    var header = parseInt(getComputedStyle(root).getPropertyValue('--header-height'), 10);
    if (Number.isFinite(header) && header > 0) return header;
    var legacy = parseInt(getComputedStyle(root).getPropertyValue('--lp-nav-offset'), 10);
    return Number.isFinite(legacy) ? legacy : NAV_OFFSET_FALLBACK;
  }

  function scrollToAnchor(id) {
    if (!id) return false;
    var target = document.getElementById(id.replace(/^#/, ''));
    if (!target) return false;
    var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - getNavOffset());
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  function initFeatureBento(root) {
    if (!root || root.dataset.lpFeatureBentoInit === 'true') return;
    root.dataset.lpFeatureBentoInit = 'true';

    var grid = root.querySelector('.lp-feature-bento__grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.lp-feature-bento-card'));
    if (!grid || !cards.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var mobileCarousel = window.matchMedia('(max-width: 749px)').matches;

    var sliderEl = root.querySelector('.lp-feature-bento__slider');
    var sliderContainer = sliderEl && sliderEl.querySelector('.slider-container');

    if (sliderEl && sliderContainer && typeof sliderEl.reInstall === 'function') {
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var onBreakpointChange = function () {
        sliderEl.reInstall();
      };
      if (typeof mobileMq.addEventListener === 'function') {
        mobileMq.addEventListener('change', onBreakpointChange);
      } else if (typeof mobileMq.addListener === 'function') {
        mobileMq.addListener(onBreakpointChange);
      }

      if (mobileMq.matches) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            sliderEl.reInstall();
          });
        });
      }

      sliderContainer.addEventListener(
        'mousedown',
        function (e) {
          if (!sliderEl.classList.contains('slider--installed')) return;
          if (!e.target.closest('.lp-feature-bento-card')) return;
          if (window.matchMedia('(hover: none)').matches) return;
          e.preventDefault();
        },
        true
      );
    }

    if (mobileCarousel) {
      cards.forEach(function (card) {
        card.classList.add('is-inview');
      });
    }

    cards.forEach(function (card) {
      card.setAttribute('draggable', 'false');
      var cardImg = card.querySelector('img');
      if (cardImg) cardImg.setAttribute('draggable', 'false');

      var pointerStartX = 0;
      var pointerStartY = 0;
      var didDrag = false;

      card.addEventListener(
        'pointerdown',
        function (e) {
          pointerStartX = e.clientX;
          pointerStartY = e.clientY;
          didDrag = false;
        },
        { passive: true }
      );

      card.addEventListener(
        'pointermove',
        function (e) {
          var dx = Math.abs(e.clientX - pointerStartX);
          var dy = Math.abs(e.clientY - pointerStartY);
          var threshold = mobileCarousel ? 14 : 8;
          if (mobileCarousel) {
            if (dx > threshold && dx > dy * 1.15) didDrag = true;
          } else if (dx > threshold || dy > threshold) {
            didDrag = true;
          }
        },
        { passive: true }
      );

      card.addEventListener('click', function (e) {
        if (sliderEl && sliderEl.classList.contains('slider--is-dragging')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        var href = card.getAttribute('href') || '';
        if (href.indexOf('#') !== 0) return;
        e.preventDefault();
        scrollToAnchor(href.slice(1));
      });

      if (hoverFine) {
        card.addEventListener('mouseenter', function () {
          grid.classList.add('is-dim-others');
          cards.forEach(function (c) {
            c.classList.toggle('is-hovered', c === card);
          });
        });
        card.addEventListener('mouseleave', function () {
          grid.classList.remove('is-dim-others');
          cards.forEach(function (c) {
            c.classList.remove('is-hovered');
          });
        });
      }
    });

    if (reducedMotion) {
      cards.forEach(function (card) {
        card.classList.add('is-inview');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          var index = cards.indexOf(card);
          var delay = Math.max(0, index) * 60;
          window.setTimeout(function () {
            card.classList.add('is-inview');
          }, delay);
          observer.unobserve(card);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initAll(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll('[data-lp-feature-bento]');
    Array.prototype.forEach.call(roots, function (root) {
      initFeatureBento(root);
    });
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-lp-feature-bento]');
    if (!root) return;
    delete root.dataset.lpFeatureBentoInit;
    initFeatureBento(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-lp-feature-bento]');
    if (root) delete root.dataset.lpFeatureBentoInit;
  });
})();
